import React, { ReactNode } from 'react'

import { Input as AntInput } from 'antd'

import './DataEntryStyles.less'

interface PasswordInputProps {
  size?: 'large' | 'small' | 'middle'
  onPressEnter?: React.KeyboardEventHandler<HTMLInputElement>
  disabled?: boolean
  defaultValue?: string
  placeholder?: string
  prefix?: ReactNode
  suffix?: ReactNode
  visibilityToggle?: boolean
  className?: string
  onChange?: React.FormEventHandler<HTMLInputElement>
  id?: string
}

const Input: React.FC<PasswordInputProps> = (props) => {
  return <AntInput.Password {...props} />
}
export default Input
